export function Help() {
  return (
    <div className="page">
      <div className="page-head">
        <h1>How tweetvia works</h1>
        <p className="lede">Three things tweetvia does for you. Start with whichever fits your day.</p>
      </div>

      <div className="card">
        <h3>1 · Write better tweets, in your voice</h3>
        <p className="helper" style={{ marginBottom: 10 }}>
          Go to <strong>Write</strong> in the sidebar. Type a topic, hit Generate, get four variants in your voice.
          For threads, switch the tab. For a take on an article, paste its URL into the <strong>from URL</strong> tab.
        </p>
        <ul className="bullet-list">
          <li>Drafts respect the X algorithm: no link in the body, no hashtag spam, ends on a take.</li>
          <li>The "from URL" tab pulls the page's headline + image and writes a caption that pairs with it.</li>
          <li>Every draft is saved in <strong>History</strong> with what you did with it.</li>
        </ul>
      </div>

      <div className="card">
        <h3>2 · Draft from any web page (Chrome extension)</h3>
        <p className="helper" style={{ marginBottom: 10 }}>
          Install the tweetvia Chrome extension. While reading any article, click the tweetvia icon — it drafts
          a tweet about that page in your voice, ready to post. Single tweet or thread.
        </p>
        <ul className="bullet-list">
          <li>Click <strong>Save</strong> on the image preview to download the article's hero image.</li>
          <li>Click <strong>Post #1 of 2 →</strong> to open X with the draft pre-loaded; drag the image into the composer.</li>
          <li>The popup also gives you the source-attribution reply to post right after.</li>
        </ul>
        <p className="helper" style={{ marginTop: 10 }}>
          Don't have the extension yet? Visit <strong>Chrome extension</strong> in the sidebar for install instructions.
        </p>
      </div>

      <div className="card">
        <h3>3 · Find conversations to engage with</h3>
        <p className="helper" style={{ marginBottom: 10 }}>
          Go to <strong>Home → Engage</strong>. Type a topic in plain English ("AI agents", "founder content") —
          we expand it into a set of search keywords. Click any keyword to open X search.
        </p>
        <ul className="bullet-list">
          <li>As you scroll the search results, our extension quietly captures notable tweets into your feed below.</li>
          <li>We rank them by relevance, author quality, freshness, and engagement velocity.</li>
          <li>Each card has Reply / Quote / Open-and-like / Dismiss buttons — Reply copies the draft and opens the tweet.</li>
        </ul>
      </div>

      <div className="card">
        <h3>4 · Your voice profile</h3>
        <p className="helper" style={{ marginBottom: 10 }}>
          Visit <strong>Voice</strong> to see how we model your writing. Every field is editable. Click
          <em> Regenerate</em> to pull your latest tweets and recompute — your manual edits are preserved.
        </p>
      </div>

      <div className="card subtle">
        <h3>Need help?</h3>
        <p className="helper">
          Found a bug, have a feature request, or got stuck? Email <strong>admin@taptapgo.org</strong> — we read every message.
        </p>
      </div>
    </div>
  );
}
